import {useEffect, useRef} from "react";
import {discardUnusedSetupEvent} from "../../utils/eventSetupStore";
import {replaceSetupEvent} from "../../utils/eventSetup";

// The surrounding workflow owns new events, not the visibility of its Setup
// panel. A desktop upload queue can take ownership before the dialog closes.
export default function useEventSetupLifecycle() {
  const lifecycle = useRef(null);
  if (!lifecycle.current) {
    const owned = new Map();
    let closed = false;
    const discard = async entries => {
      await Promise.all(entries.map(entry => discardUnusedSetupEvent(entry).catch(error => {
        console.warn("Could not remove an unused event after closing setup:", error);
      })));
    };
    lifecycle.current = {
      open() {closed = false;},
      saved(entry, created) {
        const key = `${entry.scope}:${entry.teamId || ""}:${entry.saved.eventId}`;
        if (!created && !owned.has(key)) return;
        if (entry.saved.instanceDate && owned.has(key)) {
          entry = {...entry, saved: replaceSetupEvent([owned.get(key).saved], entry.saved, entry.saved)[0]};
        }
        owned.set(key, entry);
        if (closed) {owned.delete(key); void discard([entry]);}
      },
      close() {
        closed = true;
        // Keep ownership until in-flight saves settle: an edit can finish after
        // closing and must still be eligible for cleanup of its latest version.
        const entries = [...owned.values()];
        return discard(entries);
      },
      transfer() {
        const entries = [...owned.values()]; owned.clear();
        return () => discard(entries);
      },
    };
  }
  useEffect(() => {
    const current = lifecycle.current;
    current.open();
    return () => {void current.close();};
  }, []);
  return lifecycle.current;
}
